export default String.raw`
.mainBanner {
    padding: 0 32px;

    &__slide {
        &-container {
            left: 24px;

            &-box {
                padding: 20px;
                max-width: 60%;

                h1 {
                    @include h2-headline;
                }

                h3 {
                    margin-bottom: 16px;
                    -webkit-line-clamp: 2;
                }
            }
        }

        &-placeholder {
            &::after {
                content: 'Tablet';
            }
        }
    }

    &__prev, &__next {
        visibility: hidden;
    }
}
`